import React from "react";
import { Box } from "./style";
import Textarea from "react-textarea-autosize";

export default props => {
  const formStatus = () => {
    if (props.meta) {
      if (props.meta.error) {
        return "error";
      }
    }
  };
  const notice = () => {
    if (props.meta.error) {
      return <span className="notice">{props.meta.error}</span>;
    }
  };  
  return (
    <Box status={formStatus()}>
      <Textarea
        minRows={props.minRows || 1}
        maxRows={5}
        onChange={e => props.input.onChange(e.target.value)}
        value={props.input.value}
        placeholder={props.placeholder}
      />
      {notice()}
    </Box>
  );
};
